import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './grid-layout.module.scss';

const gridLayoutPropTypes = {
  children: PropTypes.node,
  Col: PropTypes.number,
  lgCol: PropTypes.number,
  Row: PropTypes.number,
  lgRow: PropTypes.number,
  autoRows: PropTypes.bool,
  noStackMargin: PropTypes.bool
};

const gridItemPropTypes = {
  children: PropTypes.node,
  Col: PropTypes.number,
  lgCol: PropTypes.number,
  Row: PropTypes.number,
  lgRow: PropTypes.number,
  Order: PropTypes.number,
  lgOrder: PropTypes.number
};

const GridLayout = ({children, Col, lgCol, Row, lgRow, autoRows, noStackMargin}) => (
    <div
      className={classNames(styles.grid, {
        [styles[`grid--column-${ Col}`]]: Col !== undefined,
        [styles[`grid--column-lg-${ lgCol}`]]: lgCol !== undefined,
        [styles[`grid--row-${ Row}`]]: Row !== undefined,
        [styles[`grid--row-lg-${ lgRow}`]]: lgRow !== undefined,
        [styles['grid--auto-rows']]: autoRows !== undefined,
        [styles['grid--no-stack-margin']]: noStackMargin
      })}>
      {children}
    </div>
  );

const GridItem = ({children, Col, lgCol, Row, lgRow, Order, lgOrder}) => (
    <div
      className={classNames(styles['grid-item'], {
        [styles[`grid-item--column-${ Col}`]]: Col !== undefined,
        [styles[`grid-item--column-lg-${ lgCol}`]]: lgCol !== undefined,
        [styles[`grid-item--row-${ Row}`]]: Row !== undefined,
        [styles[`grid-item--row-lg-${ lgRow}`]]: lgRow !== undefined,
        [styles[`grid-item--order-${ Order}`]]: Order !== undefined,
        [styles[`grid-item--order-lg-${ lgOrder}`]]: lgOrder !== undefined
      })}>
      {children}
    </div>
  );

GridLayout.propTypes = gridLayoutPropTypes;
GridItem.propTypes = gridItemPropTypes;

export {GridLayout, GridItem};
